module.exports = __webpack_public_path__ + "assets/media/chat-with-bot.ba8bbf21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookWebinarStep/chat-with-bot.svg
// module id = 3033
// module chunks = 0